import { HomePage } from "@/components/acendex/page/home/home";

export function AcendexHome() {
  return <HomePage />;
}
